export const BLANK_WINDOW: string = '_blank';
